import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "underscore";

import { Icon } from "..";

export class SelectInput extends Component {

	constructor(props) {
		super(props);

		this.state = {
			multipleLength: props.multiple && props.value.length
		};
	}

	componentDidMount() {
		$(`.input-field > select#${this.props.id}`).on("change", e => {
			this.props.changeAction(e);
		}).material_select();
	}

	componentWillReceiveProps(nextProps) {
		if(nextProps.options != this.props.options) {
			$(`.input-field > .select-wrapper > select#${this.props.id}`)
				.append(this.renderOptions(nextProps.options));
		}
		if(nextProps.multiple && !!nextProps.value.length) this.setState({ multipleLength: true });
		else if(nextProps.multiple) this.setState({ multipleLength: false });
	}

	componentDidUpdate(prevProps, prevState) {
		if(!this.props.multiple ||
			_.difference(this.props.options, prevProps.options).length && !this.props.static ||
			(this.props.value.length && this.props.options.length && !this.props.init) ||
			prevProps.init != this.props.init ||
			this.props.disabled != prevProps.disabled
		)
			$(`.input-field > .select-wrapper > select#${this.props.id}`).material_select();
	}

	componentWillUnmount() {
		$(".input-field > select").material_select("destroy");
	}

	renderOptions(options) {
		options = options || this.props.options;
		options = options.map((o, i) => 
			<option
				key={o.value + i}
				value={o.value}
				className={o.icon ? "left" : ""}
				data-icon={o.icon}
			>
				{o.label}
			</option>
		);
		return options;
	}

	render() {
		const {
			id,
			className,
			defaultLabel,
			label,
			options,
			value,
			multiple,
			error,
			disabled
		} = this.props;
		const { multipleLength } = this.state;

		return (
			<div
				id={id}
				className={
					`input-field ${className ? className : ""}${multipleLength ? " -multiple-length" : ""}`
				}
			>
				{ error ? <div className="error-text">{error}</div> : null }
				<select
					disabled={disabled}
					value={value}
					id={id}
					multiple={multiple}
					id={id}
					className={`${error ? "invalid" : ""}${value.length ? "" : " -not-selected"}`}
					onChange={e => console.log(e)}
				>
					{
						defaultLabel ?
						<option className="default-label" value="" disabled>{defaultLabel}</option> :
						null
					}
					{this.renderOptions()}
				</select>
				{
					label ?
					<label>{label}</label> :
					null
				}
			</div>
		);
	}
}

const option = PropTypes.shape({
	value: PropTypes.string,
	label: PropTypes.string
});

SelectInput.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	options: PropTypes.arrayOf(option).isRequired,
	className: PropTypes.string,
	changeAction: PropTypes.func.isRequired,
	defaultLabel: PropTypes.string.isRequired,
	multiple: PropTypes.bool
};

SelectInput.defaultProps = {
	id: "",
	label: "",
	options: [],
	className: "",
	changeAction: () => console.log("CHANGE ACTION NOT IMPLEMENTED"),
	defaultLabel: "",
	multiple: false
};


// WEBPACK FOOTER //
// src/atoms/lib/SelectInput.js